import React from 'react';
import { RoleNames, investorRoles } from 'utils/constants';
import { texts } from 'utils/languages/fr';

const Subscriptions = React.lazy(() => import('containers/subscriptions/Subscriptions'));
const ServicerUsers = React.lazy(() => import('containers/users/servicer-users'));
const ProviderUsers = React.lazy(() => import('containers/users/provider-users'));
const Investors = React.lazy(() => import('containers/investors'));
const Dashboard = React.lazy(() => import('containers/dashboard'));
const InvestorDocuments = React.lazy(() => import('containers/investor-pages/InvestorDocuments'));
const InvestorMessages = React.lazy(() => import('containers/investor-pages/InvestorMessages'));
const InvestorAccount = React.lazy(() => import('containers/investor-pages/InvestorAccount'));
const FundManagement = React.lazy(() => import('containers/funds/fund-management/FundManagement'));
const CapitalCalls = React.lazy(() => import('containers/funds/capital-calls/CapitalCalls'));
const CapitalAccounts = React.lazy(() => import('containers/capital-accounts'));
const Abandonner = React.lazy(() => import('containers/tunnel/abandonner'));
const Distributors = React.lazy(() => import('containers/distributors'));
const Networks = React.lazy(() => import('containers/networks'));
const DistributorUsers = React.lazy(() => import('containers/users/distributor-users'));
const Communication = React.lazy(() => import('containers/communication'));
const DistributorRemunerations = React.lazy(() => import('containers/distributor-remunerations'));
const Reporting = React.lazy(() => import('containers/reporting'));
const DistributorDocuments = React.lazy(() => import('containers/distributor-documents'));
const SentMessages = React.lazy(() => import('containers/sent-messages'));
const DirectDebitToFunds = React.lazy(() =>
    import('containers/payments/direct-debits/DirectDebitToFunds')
);
const CreditTransfers = React.lazy(() =>
    import('containers/payments/credit-transfers/CreditTransfers')
);
const SentSubscriptions = React.lazy(() => import('containers/sent-subscriptions'));
const InvestorsAccounts = React.lazy(() =>
    import('containers/investors-accounts/InvestorAccounts')
);
const AddIndirectSubscription = React.lazy(() =>
    import('containers/tunnel/tunnel-entry/AddIndirectSubscription')
);
const Portfolio = React.lazy(() => import('containers/portfolio/Portfolio'));
const Closings = React.lazy(() => import('containers/closings/Closings'));
const SGPCompanies = React.lazy(() => import('containers/sgp-companies/SGPCompanies'));
const DistributorHomepage = React.lazy(() => import('containers/homepage/DistributorHomepage'));
const Promoters = React.lazy(() => import('containers/promoters/Promoters'));
const PromoterUsers = React.lazy(() => import('containers/users/promoter-users/PromoterUsers'));

const TunnelIframe = React.lazy(() => import('containers/tunnel/common/TunnelIframe'));
const InvestorTunnel = React.lazy(() => import('containers/tunnel/InvestorTunnel'));
const NewSubscription = React.lazy(() => import('containers/tunnel/NewSubscription'));
const DistributorTunnel = React.lazy(() =>
    import('containers/tunnel/onboarding/DistributorTunnel')
);

export default [
    {
        key: 'homepage',
        path: '/homepage',
        role: [RoleNames.ADMIN_CIF, RoleNames.PSI, RoleNames.COMMERCIALISATEUR],
        exact: true,
        protected: true,
        label: texts.HOMEPAGE,
        component: DistributorHomepage,
    },
    {
        key: 'dashboard',
        path: '/dashboard',
        role: Object.values(RoleNames).filter(
            role =>
                ![RoleNames.ADMIN_CIF, RoleNames.PSI, RoleNames.COMMERCIALISATEUR].includes(role)
        ),
        exact: true,
        protected: true,
        label: texts.HOMEPAGE,
        component: Dashboard,
    },
    {
        key: 'dashboard',
        path: '/dashboard',
        role: [RoleNames.ADMIN_CIF, RoleNames.PSI, RoleNames.COMMERCIALISATEUR],
        exact: true,
        protected: true,
        label: texts.DASHBOARD,
        component: Dashboard,
    },
    {
        key: 'subscriptions',
        path: '/subscriptions/*',
        role: [
            RoleNames.SERVICER_ADMIN,
            RoleNames.SERVICER_SIGNATORY,
            RoleNames.SERVICER_STANDARD,
            RoleNames.NETWORK_ADMIN,
            RoleNames.ADMIN_CIF,
            RoleNames.PSI,
            RoleNames.COMMERCIALISATEUR,
            RoleNames.PROVIDER_ADMIN,
            RoleNames.PROVIDER_SIGNATORY,
            RoleNames.PROVIDER_STANDARD,
            RoleNames.PROMOTER_ADMIN,
            RoleNames.PROMOTER_STANDARD,
        ],
        protected: true,
        label: texts.ONGOING,
        parentLabel: texts.SUBSCRIPTIONS,
        component: Subscriptions,
    },
    {
        key: 'investors',
        path: '/investors/*',
        absolutePath: '/investors',
        role: [
            RoleNames.SERVICER_ADMIN,
            RoleNames.SERVICER_SIGNATORY,
            RoleNames.SERVICER_STANDARD,
            RoleNames.ADMIN_CIF,
            RoleNames.PSI,
            RoleNames.COMMERCIALISATEUR,
            RoleNames.NETWORK_ADMIN,
            RoleNames.PROVIDER_ADMIN,
            RoleNames.PROVIDER_SIGNATORY,
            RoleNames.PROVIDER_STANDARD,
            RoleNames.PROMOTER_ADMIN,
            RoleNames.PROMOTER_STANDARD,
        ],
        protected: true,
        label: texts.FINISHED,
        parentLabel: texts.SUBSCRIPTIONS,
        component: Investors,
    },
    {
        key: 'sent-subscriptions',
        path: '/sent-subscriptions',
        role: [RoleNames.SERVICER_ADMIN, RoleNames.SERVICER_SIGNATORY, RoleNames.SERVICER_STANDARD],
        protected: true,
        label: texts.SENT_MULTIPLE,
        parentLabel: texts.SUBSCRIPTIONS,
        component: SentSubscriptions,
    },
    {
        key: 'investor-accounts',
        path: '/investor-accounts/*',
        absolutePath: '/investor-accounts',
        role: [
            RoleNames.SERVICER_ADMIN,
            RoleNames.SERVICER_SIGNATORY,
            RoleNames.SERVICER_STANDARD,
            RoleNames.ADMIN_CIF,
            RoleNames.PSI,
            RoleNames.COMMERCIALISATEUR,
            RoleNames.PROMOTER_ADMIN,
            RoleNames.PROMOTER_STANDARD,
        ],
        protected: true,
        label: texts.CLIENT_ACCOUNTS,
        component: InvestorsAccounts,
    },
    {
        key: 'sgp-companies',
        path: '/sgp-companies/*',
        absolutePath: '/sgp-companies',
        role: [RoleNames.SERVICER_ADMIN, RoleNames.SERVICER_SIGNATORY],
        protected: true,
        label: texts.SGP_PROVIDERS,
        component: SGPCompanies,
    },
    {
        key: 'promoters',
        path: '/promoters/*',
        absolutePath: '/promoters',
        role: [RoleNames.SERVICER_ADMIN, RoleNames.SERVICER_SIGNATORY],
        protected: true,
        label: texts.PROMOTERS,
        component: Promoters,
    },
    {
        key: 'servicer-users',
        path: '/servicer-users/*',
        absolutePath: '/servicer-users',
        role: [RoleNames.SERVICER_ADMIN, RoleNames.SERVICER_SIGNATORY],
        protected: true,
        label: texts.SERVICER_USERS,
        parentLabel: texts.USERS,
        component: ServicerUsers,
    },
    {
        key: 'provider-users',
        path: '/provider-users/*',
        absolutePath: '/provider-users',
        role: [
            RoleNames.SERVICER_ADMIN,
            RoleNames.SERVICER_SIGNATORY,
            RoleNames.PROVIDER_ADMIN,
            RoleNames.PROVIDER_SIGNATORY,
        ],
        protected: true,
        label: texts.PROVIDER_USERS,
        parentLabel: texts.USERS,
        component: ProviderUsers,
    },
    {
        key: 'promoter-users',
        path: '/promoter-users/*',
        absolutePath: '/promoter-users',
        role: [RoleNames.SERVICER_ADMIN, RoleNames.SERVICER_SIGNATORY, RoleNames.PROMOTER_ADMIN],
        protected: true,
        label: texts.PROMOTER_USERS,
        parentLabel: texts.USERS,
        component: PromoterUsers,
    },
    {
        key: 'distributor-users',
        path: '/distributor-users/*',
        absolutePath: '/distributor-users',
        role: [RoleNames.SERVICER_ADMIN, RoleNames.SERVICER_SIGNATORY],
        protected: true,
        label: texts.DISTRIBUTOR_USERS,
        parentLabel: texts.USERS,
        component: DistributorUsers,
    },
    {
        key: 'distributors',
        path: '/distributors/*',
        absolutePath: '/distributors',
        role: [
            RoleNames.SERVICER_ADMIN,
            RoleNames.SERVICER_SIGNATORY,
            RoleNames.SERVICER_STANDARD,
            RoleNames.PROVIDER_ADMIN,
            RoleNames.PROVIDER_SIGNATORY,
            RoleNames.PROVIDER_STANDARD,
            RoleNames.NETWORK_ADMIN,
            RoleNames.PROMOTER_ADMIN,
            RoleNames.PROMOTER_STANDARD,
        ],
        protected: true,
        label: texts.DISTRIBUTEUR_LIST_TITLE,
        component: Distributors,
    },
    {
        key: 'networks',
        path: '/networks/*',
        absolutePath: '/networks',
        role: [RoleNames.SERVICER_ADMIN, RoleNames.SERVICER_SIGNATORY, RoleNames.SERVICER_STANDARD],
        protected: true,
        label: texts.NETWORKS,
        component: Networks,
    },
    {
        key: 'fund-management',
        path: '/fund-management/*',
        absolutePath: '/fund-management',
        role: [RoleNames.SERVICER_ADMIN, RoleNames.SERVICER_SIGNATORY],
        protected: true,
        label: texts.FUND,
        component: FundManagement,
    },
    {
        key: 'fund-calls',
        path: '/fund-calls',
        role: [RoleNames.SERVICER_ADMIN, RoleNames.SERVICER_SIGNATORY],
        protected: true,
        label: texts.FUND_CALLS,
        parentLabel: texts.FUNDS_LIFE,
        component: CapitalCalls,
    },
    {
        key: 'closings',
        path: '/closings',
        role: [RoleNames.SERVICER_ADMIN, RoleNames.SERVICER_SIGNATORY],
        protected: true,
        label: texts.CLOSINGS,
        parentLabel: texts.FUNDS_LIFE,
        component: Closings,
    },
    {
        key: 'reporting',
        path: '/reporting',
        role: [
            RoleNames.SERVICER_ADMIN,
            RoleNames.SERVICER_SIGNATORY,
            RoleNames.ADMIN_CIF,
            RoleNames.PSI,
            RoleNames.COMMERCIALISATEUR,
        ],
        protected: true,
        label: texts.REPORTING,
        parentLabel: texts.FUNDS_LIFE,
        component: Reporting,
    },
    {
        key: 'capital-accounts',
        path: '/capital-accounts',
        role: [RoleNames.SERVICER_ADMIN, RoleNames.SERVICER_SIGNATORY],
        protected: true,
        label: texts.CAPITAL_ACCOUNTS,
        parentLabel: texts.FUNDS_LIFE,
        component: CapitalAccounts,
    },
    {
        key: 'direct-debit-to-funds',
        path: '/direct-debit-to-funds',
        role: [
            RoleNames.SERVICER_ADMIN,
            RoleNames.SERVICER_SIGNATORY,
            RoleNames.SERVICER_STANDARD,
            RoleNames.ADMIN_CIF,
            RoleNames.PSI,
            RoleNames.COMMERCIALISATEUR,
            RoleNames.PROMOTER_ADMIN,
            RoleNames.PROMOTER_STANDARD,
        ],
        protected: true,
        label: texts.DIRECT_DEBIT_TO_FUNDS,
        parentLabel: texts.FINANCIAL_FLOW,
        component: DirectDebitToFunds,
    },
    {
        key: 'transfer-to-funds',
        path: '/transfer-to-funds',
        role: [
            RoleNames.SERVICER_ADMIN,
            RoleNames.SERVICER_SIGNATORY,
            RoleNames.SERVICER_STANDARD,
            RoleNames.ADMIN_CIF,
            RoleNames.PSI,
            RoleNames.COMMERCIALISATEUR,
            RoleNames.PROMOTER_ADMIN,
            RoleNames.PROMOTER_STANDARD,
        ],
        protected: true,
        label: texts.TRANSFER_TO_FUNDS,
        parentLabel: texts.FINANCIAL_FLOW,
        component: CreditTransfers,
    },
    {
        key: 'sent-messages',
        path: '/sent-messages',
        role: [
            RoleNames.SERVICER_ADMIN,
            RoleNames.SERVICER_SIGNATORY,
            RoleNames.ADMIN_CIF,
            RoleNames.COMMERCIALISATEUR,
            RoleNames.PSI,
        ],
        protected: true,
        label: texts.SENT_MESSAGES,
        component: SentMessages,
    },
    {
        key: 'my-account',
        path: '/my-account',
        role: investorRoles,
        exact: true,
        protected: true,
        label: texts.MON_COMPTE,
        component: InvestorAccount,
    },
    {
        key: 'investor-messages',
        path: '/investor-messages',
        role: investorRoles,
        exact: true,
        protected: true,
        label: texts.MY_MESSAGES,
        component: InvestorMessages,
    },
    {
        key: 'investor-documents',
        path: '/investor-documents',
        role: investorRoles,
        exact: true,
        protected: true,
        label: texts.MY_DOCUMENTS,
        component: InvestorDocuments,
    },
    {
        key: 'distributor-documents',
        path: '/distributor-documents',
        role: [RoleNames.ADMIN_CIF, RoleNames.PSI],
        protected: true,
        label: texts.DOCUMENTS,
        component: DistributorDocuments,
    },
    {
        key: 'distributor-remunerations',
        path: '/distributor-remunerations',
        role: [RoleNames.ADMIN_CIF, RoleNames.PSI],
        protected: true,
        label: texts.REMUNERATIONS,
        component: DistributorRemunerations,
    },
    {
        key: 'distributor-users',
        path: '/distributor-users/*',
        absolutePath: '/distributor-users',
        role: [RoleNames.ADMIN_CIF, RoleNames.PSI],
        protected: true,
        label: texts.USERS,
        component: DistributorUsers,
    },
    {
        key: 'communication',
        path: '/communication',
        role: [RoleNames.ADMIN_CIF, RoleNames.PSI],
        protected: true,
        label: texts.COMMUNICATIONS,
        component: Communication,
    },
    {
        key: 'tunnel-page',
        path: '/sign-up/*',
        role: investorRoles,
        exact: false,
        label: texts.GENERIC_STEP_PAGE,
        component: InvestorTunnel,
    },
    {
        key: 'create-subscription',
        path: '/create-subscription/*',
        role: [RoleNames.ADMIN_CIF, RoleNames.COMMERCIALISATEUR, RoleNames.PSI],
        exact: true,
        label: texts.GENERIC_STEP_PAGE,
        component: InvestorTunnel,
    },
    {
        key: 'add-indirect-subscription',
        path: '/add-indirect-subscription',
        role: [RoleNames.ADMIN_CIF, RoleNames.COMMERCIALISATEUR, RoleNames.PSI],
        exact: true,
        label: texts.GENERIC_STEP_PAGE,
        component: AddIndirectSubscription,
    },
    {
        key: 'tunnel-iframe-success',
        path: '/sign-up-success',
        role: [],
        exact: true,
        label: texts.GENERIC_STEP_PAGE,
        component: TunnelIframe,
    },
    {
        key: 'tunnel-iframe-error',
        path: '/sign-up-error',
        role: [],
        exact: true,
        label: texts.GENERIC_STEP_PAGE,
        component: TunnelIframe,
    },
    {
        key: 'abandonner',
        path: '/abandonner',
        exact: true,
        role: [],
        label: texts.ABANDONNER,
        component: Abandonner,
    },
    {
        key: 'onboarding',
        path: '/onboarding/*',
        role: [],
        exact: true,
        component: DistributorTunnel,
    },
    {
        key: 'new-subscription',
        path: '/new-subscription/*',
        role: investorRoles,
        exact: true,
        component: NewSubscription,
    },
    {
        key: 'portfolio',
        path: '/portfolio',
        role: investorRoles,
        exact: true,
        component: Portfolio,
    },
];
